type VersionWithDocumentPages = {
  document?: {
    pages?: {
      entries: ReadonlyArray<{ uuid?: string | null } | undefined>
    } | null
  } | null
} | null

/**
 * Resolves the permanent page UUID for a share view.
 *
 * The pageUUID is only present in the URL for non-default pages; on the default
 * (first) page the route omits it, so we fall back to the first document page.
 * Centralizing this keeps every call site consistent and avoids the malformed
 * page URLs that result when the fallback is missed (e.g. `.../p//sc/...`).
 *
 * This takes the values the caller already has (the URL pageUUID and the current
 * version) instead of calling hooks, so it does not re-mount `useParams` /
 * `useVersioning` that the parent already provides.
 */
export const getPermanentPageId = (
  pageUUIDFromUrl: string | undefined,
  currentVersion: VersionWithDocumentPages | undefined
): string | undefined =>
  pageUUIDFromUrl ??
  currentVersion?.document?.pages?.entries[0]?.uuid ??
  undefined
